<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <button class="btn btn-outline-primary" @click.prevent="backtolist">&lt; Return to list</button>
      <h3 class="mb-0 ms-4" v-if="partner_id > 0">{{partner_name}}</h3>
      <h3 class="mb-0 ms-4" v-if="partner_id < 0">Add Partner</h3>
    </div>
    <ul class="nav nav-tabs col-12 px-0 mx-0 mt-2" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active text-center w-100" id="general-tab" data-bs-toggle="tab" data-bs-target="#general" type="button" role="tab">
          General Information
        </button>
      </li>
    </ul>
    
    <div class="tab-content mt-3">
      <div class="tab-pane fade show active px-0 col-12 border-0" id="general" role="tabpanel">
        <div class="card border-0 mx-0 px-0 col-12">
          <div class="card-body p-0">
            <div class="row">
              <div class="col-8">
                <form autocomplete="off" @submit.stop.prevent>
                  <!-- Partner name -->
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0;">Partner name</label>
                    <div style="width: 58%;">
                      <input
                        id="partner_name"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': partner_name_valid === false }"
                        v-model="partner_name"
                        @change="savefield('g_partners',partner_id,'partner_name',partner_name)"
                        autocomplete="off"
                      >
                      <div class="invalid-feedback">Partner name cannot be blank</div>
                    </div>
                  </div>

                  <!-- Partner address -->
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0;">Partner address</label>
                    <div style="width: 58%;">
                      <input
                        id="partner_address_1"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': partner_address_valid === false }"
                        v-model="partner_address_1"
                        @change="savefield('g_partners',partner_id,'partner_address_1',partner_address_1)"
                        autocomplete="off"
                      >
                      <div class="invalid-feedback">Partner address cannot be blank</div>
                    </div>
                  </div>

                  <!-- Partner address 2 -->
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0;"></label>
                    <div style="width: 58%;">
                      <input
                        id="partner_address_2"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': partner_address_valid === false }"
                        v-model="partner_address_2"
                        @change="savefield('g_partners',partner_id,'partner_address_2',partner_address_2)"
                        autocomplete="off"
                      >
                    </div>
                  </div>

                  <!-- Zip code -->
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0;">Zip code</label>
                    <div style="width: 58%;">
                      <input
                        id="partner_zip_code"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': partner_address_valid === false }"
                        v-model="partner_zip_code"
                        @change="savefield('g_partners',partner_id,'partner_zip_code',partner_zip_code)"
                        autocomplete="off"
                      >
                    </div>
                  </div>

                  <!-- City -->
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0;">City</label>
                    <div style="width: 58%;">
                      <input
                        id="partner_city"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': partner_address_valid === false }"
                        v-model="partner_city"
                        @change="savefield('g_partners',partner_id,'partner_city',partner_city)"
                        autocomplete="off"
                      >
                    </div>
                  </div>

                  <!-- Country -->
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0;">Country</label>
                    <div style="width: 58%;">
                      <select
                        id="partner_country_id"
                        class="form-select"
                        :class="{ 'is-invalid': partner_country_id_valid === false }"
                        v-model="partner_country_id"
                        @change="savefield('g_partners',partner_id,'partner_country_id',partner_country_id)"
                        autocomplete="off"
                      >
                        <option v-for="country in countries" :key="country.value" :value="country.value">
                          {{ country.text }}
                        </option>
                      </select>
                      <div class="invalid-feedback">You must select a country</div>
                    </div>
                  </div>

                  <!-- Partner registration number -->
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0;">Partner registration number</label>
                    <div style="width: 58%;">
                      <input
                        id="partner_registration_number"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': partner_address_valid === false }"
                        v-model="partner_registration_number"
                        @change="savefield('g_partners',partner_id,'partner_registration_number',partner_registration_number)"
                        autocomplete="off"
                      >
                    </div>
                  </div>

                  <!-- Partner e-mail -->
                  <div class="mb-3 d-flex align-items-center">
                    <label class="col-form-label" style="width: 33%; flex-shrink: 0;">Partner e-mail</label>
                    <div style="width: 58%;">
                      <input
                        id="partner_email"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': partner_address_valid === false, 'g-anon': anon }"
                        v-model="partner_email"
                        @change="savefield('g_partners',partner_id,'partner_email',partner_email)"
                        autocomplete="off"
                      >
                    </div>
                  </div>

                  <!-- Save button for new partner -->
                  <div class="mt-4 d-flex" v-if="partner_id < 1">
                    <div style="width: 33%; flex-shrink: 0;"></div>
                    <div style="width: 58%;">
                      <button
                        class="btn btn-primary"
                        @click.prevent="partner_create"
                      >
                        Save New Partner
                      </button>
                    </div>
                  </div>
                </form>

                <div v-if="partner_id > 0" class="form-group col-12 text-start">
                  <span class="col-12 px-0 mx-0 pt-2 pb-4">Labels</span><br>
                  <span 
                    v-for="label in labels" 
                    :key="label.id" 
                    :style="{ 'background': '#'+label.color}" 
                    class="me-2 py-1 ps-2 pe-2 rounded"
                  >
                    {{ label.label }}
                    <span 
                      @click.stop.prevent="removelabel(label.id)"
                      class="ms-2"
                      style="cursor: pointer;"
                    >
                      <fa-icon name="trash-alt" />
                    </span>
                  </span>
                  <span 
                    v-show="addinglabel==0"
                    class="icon-plus pt-0 text-primary"
                    :class="labels.length==0?'pt-2':'pt-0'"
                    @click.stop.prevent="addlabel(partner_id)"
                    style="cursor: pointer;"
                  >
                  </span>

                  <!-- Add label input -->
                  <div 
                    v-show="addinglabel==partner_id"
                    class="input-group input-group-sm col-3 ps-0 ms-0 py-0 my-0 mt-2"
                  >
                    <input
                      class="form-control form-control-sm py-0"
                      v-model="addinglabeltext"
                      placeholder="Add label"
                      type="text"
                      @keyup.enter.prevent="saveaddlabel"
                      @keyup.escape.prevent="addinglabel = 0"
                      autocomplete="off"
                      ref="addinglabel"
                    >
                    <span class="input-group-text py-0">
                      <button
                        class="btn btn-link btn-sm p-0"
                        @click="addinglabel = 0"
                      >
                        X
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  components: {
  },
  name: 'Partner',
  created() {
    this.countries_get();
    this.partner_get();
  },
  data: function() {
    return {
      partner_name: '',
      partner_name_valid: null,
      partner_address_1: '',
      partner_address_valid: null,
      partner_address_2: '',
      partner_zip_code: '',
      partner_zip_code_valid: null,
      partner_city: '',
      partner_city_valid: null,
      partner_registration_number: '',
      partner_registration_number_valid: null,
      partner_country_id: 0,
      partner_country_id_valid: null,
      partner_email: '',
      partner_email_valid: null,
      countries: [],
      labels: [],
      addinglabel: 0,
      addinglabeltext: '',
      loading: true,
    }
  },
  computed: {
    anon: function() {
      return this.$store.state.anon;
    },
    partner_id: {
      get() {
        return this.$store.state.currentpartner_id;
      }
    },
    emailinvalidfeedback() {
      if (this.email == '') { return "E-mail is invalid"; }
      // eslint-disable-next-line
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email) == false) {
        return "Incorrect e-mail format";
      }
      return "E-mail already exists";
    }
  },
  watch: {
    partner_id: function() {
      this.partner_get()
    }
  },
  methods: {
    checkform() {
      var formok = true;
      this.partner_name_valid = true;
      if (this.partner_name == '') { 
        this.partner_name_valid = false; 
        formok = false;
      }
      return formok;
    },
    partner_create() {
      if (this.checkform()) {
        var partner = {
          partner_name: this.partner_name,
          partner_address_1: this.partner_address_1,
          partner_address_2: this.partner_address_2,
          partner_zip_code: this.partner_zip_code,
          partner_city: this.partner_city,
          partner_country_id: this.partner_country_id,
          partner_registration_number: this.partner_registration_number,
          partner_email: this.partner_email,
        }
        this.$store.dispatch('partner_create', { partner: partner })
        .then((resp) => {
          var partner_id = resp.data.id;
          this.$store.dispatch('partner_setcurrent',{ partner_id: partner_id })
          .then(() => {
            this.partner_get();
          });
        });
      }
    },
    savefield(tablename,id,fieldname,value) {
      if ( id > 0 ) {
        if (this.checkform()) {
          var record = {
            id: id,
            [fieldname]: value,
          }
          this.$store.dispatch('field_save', { tablename: tablename,record: record })
          .then(() => {
            this.$store.dispatch('partnerchanged_set',{ partner_id: this.partner_id });
          });
        }
      }
    },
    partner_get() {
      this.partner_name = '';
      this.labels = [];
      if (this.partner_id > 0) {
        this.$store.dispatch('partner_fetch', { partner_id: this.partner_id })
        .then((resp) => {
          this.partner_name = resp.data.partner_name;
          this.partner_address_1 = resp.data.partner_address_1;
          this.partner_address_2 = resp.data.partner_address_2;
          this.partner_zip_code = resp.data.partner_zip_code;
          this.partner_city = resp.data.partner_city;
          this.partner_country_id = resp.data.partner_country_id;
          this.partner_registration_number = resp.data.partner_registration_number;
          this.partner_email = resp.data.partner_email;
          this.labels = resp.data.labels;
          this.loading = false;
        });
      }
    },
    backtolist() {
      this.$store.dispatch('partner_setcurrent',{ partner_id: 0 })
    },
    conslabels_get() {
      this.$store.dispatch('partner_fetch', { partner_id: this.partner_id })
      .then((resp) => {
        this.labels = resp.data.labels;
      });
    },
    saveaddlabel() {
      if (this.addinglabeltext != '') {
        var savelabel = {
          partner_id: this.addinglabel,
          label: this.addinglabeltext,
        }
        this.$store.dispatch('partnerlabel_add', { label: savelabel })
        .then(()=> {
          this.conslabels_get();
          this.$store.dispatch('partnerlabelchanged_set', { partner_id: this.partner_id });
        });
      }
      this.addinglabel = 0;
      this.addinglabeltext = '';
    },
    addlabel(id) {
      this.addinglabel = id;
      this.addinglabeltext = '';
      this.$nextTick(() => this.$refs.addinglabel.focus())
    },
    removelabel(partnerlabel_id) {
      this.$store.dispatch('partnerlabel_delete', { id: partnerlabel_id })
      .then(()=> {
        this.conslabels_get();
        this.$store.dispatch('partnerlabelchanged_set', { partner_id: this.partner_id });
      });
    },
    countries_get() {
      this.$store.dispatch('countries_fetch')
      .then((resp) => {
        this.countries = [];
        for (var i=0;i<resp.data.result.length;i++) {
          var countryoption = {
            value: resp.data.result[i].id,
            text: resp.data.result[i].country_name,
          }
          this.countries.push(countryoption);
        }
      });
    },
  }
}
</script>
